import { Component } from '@angular/core';

@Component({
  selector: 'app-energy-interface-list',
  styleUrls: ['./energy-interface-list.css'],
  templateUrl: './energy-interface-list.html',
})
export class EnergyInterfaceList {}
